import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useRouter } from "../../helper-functions/useRouterReplacement";
import { useSearchParams } from "react-router-dom";
import { Grid } from "@mui/material";
import CustomShimmerForProfile from "./Shimmer";
import ProfileStatistics from "./ProfileStatistics";
import useGetUserInfo from "../../api-manage/hooks/react-query/user/useGetUserInfo";
import { getAmountWithSign } from "../../helper-functions/CardHelpers";
import BasicInformation from "./basic-information";
import { setWalletAmount } from "../../redux/slices/cart";
import { setUser } from "../../redux/slices/profileInfo";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import UserInformation from "../user-information/UserInformation";
const user = `${process.env.PUBLIC_URL}/static/profile/profile.png`;
const wallet = `${process.env.PUBLIC_URL}/static/profile/wallet.png`;
const loyalty = `${process.env.PUBLIC_URL}/static/profile/loyality.png`;
const order = `${process.env.PUBLIC_URL}/static/profile/image 38 (2).png`;

const Profile = (props) => {
  const {
    configData,
    setEditProfile,
    editProfile,
    setAddAddress,
    addAddress,
    editAddress,
    addressRefetch,
    setEditAddress,
  } = props;
  const { t } = useTranslation();
  const router = useRouter();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const page = searchParams.get('page');
  
  const handleSuccess = (res) => {
    localStorage.setItem("wallet_amount", res?.wallet_balance);
    dispatch(setWalletAmount(res?.wallet_balance));
    dispatch(setUser(res));
  };
  const { data, refetch } = useGetUserInfo(handleSuccess);
  
  // If there's a page query parameter, render UserInformation instead
  if (page) {
    return <UserInformation page={page} configData={configData} />;
  }
  
  return (
    <>
      <BasicInformation
        data={data}
        refetch={refetch}
        configData={configData}
        t={t}
        editProfile={editProfile}
        setEditProfile={setEditProfile}
        addAddress={addAddress}
        setAddAddress={setAddAddress}
        editAddress={editAddress}
        addressRefetch={addressRefetch}
        setEditAddress={setEditAddress}
      />
    </>
  );
};

Profile.propTypes = {};

export default Profile;
